import React, { Component } from 'react';
import { SlPageTitle } from './editors'
import { metadataService } from '../_services';

export class NoBusinessInState extends Component {
    render() {
        return (
            <div>
                <SlPageTitle pageName="YourInformation" />
                <div className="text-center">
                    {metadataService.getMessage("NoBusinessInState")}
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/NoBusinessInState.jsx